/**
 * SiteFormData 모델 - 폼 편집용 객체
 */

import { ISitePublic } from './SitePublic';

/**
 * 회사 폼 데이터 인터페이스
 */
export interface ICompanyFormData {
  seq: number | null;
  companyName: string;
}

/**
 * 프로젝트 폼 데이터 인터페이스
 */
export interface IProjectFormData {
  seq: number | null;
  name: string;
}

/**
 * 폼 편집용 사이트 인터페이스
 */
export interface ISiteFormData extends ISitePublic {
  siteImageFile?: File | null; // UI 전용 필드
}

/**
 * 기본값 객체들
 */
export const SiteFormDataDefaults = {
  formData: {
    seq: null,
    name: '',
    address: '',
    establishedDate: null,
    pvModuleMaker: '',
    powerCapacity: 0,
    pvModuleCount: 0,
    pvModuleOutput: 0,
    description: '',
    rotation: null,
    location: {
      coordinates: [0, 0],
      crs: { properties: { name: 'EPSG:4326' }, type: 'name' },
      type: 'Point'
    },
    ownerCompany: { seq: null, companyName: '' },
    operationCompany: { seq: null, companyName: '' },
    managers: [],
    status: 'active',
    type: 'solar',
    project: { seq: null, name: '' },
    panelProductSeq: null,
    siteImageFile: null
  } as ISiteFormData
};

/**
 * 팩토리 함수들
 */
export const SiteFormDataFactory = {
  /**
   * 빈 폼 데이터 생성
   */
  createEmpty(): ISiteFormData {
    return { ...SiteFormDataDefaults.formData };
  },
  
  /**
   * SitePublic에서 폼 데이터 생성
   */
  fromSitePublic(sitePublic: ISitePublic): ISiteFormData {
    if (!sitePublic) return this.createEmpty();
    return {
      ...sitePublic,
      siteImageFile: null
    };
  },
  
  /**
   * 폼 데이터를 SitePublic로 변환
   */
  toSitePublic(formData: ISiteFormData): ISitePublic | null {
    if (!formData) return null;
    
    // siteImageFile 제외하고 SitePublic 형태로 변환
    const { siteImageFile, ...sitePublic } = formData;
    return sitePublic;
  }
};

/**
 * 기본 export
 */
export default {
  SiteFormDataDefaults,
  SiteFormDataFactory
};
